import styled from "styled-components"
interface Show_styled_props {
  show: boolean
}

export const FirstFloorStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 336px;
  padding: 15px 15px 0 15px;
  border-radius: 20px 20px 0 0;
  /* background: rgba(48, 30, 86, 0.85); */
`
export const LiveBets = styled.div`
  color: #c7c7c7;
  font-size: 12px;
  font-weight: 700;
  line-height: 15px;
  span {
    color: #ffb000;
  }
`
export const ShowStats = styled.div<Show_styled_props>`
  border: 2px solid ${({ show }) => (show ? "#ff0000" : "#ffb000")};
  color: ${({ show }) => (show ? "#ff0000" : "#ffb000")};
  border-radius: 40px;
  font-weight: 700;
  font-size: 10px;
  padding: 3px 10px;
  transition: all 0.5s;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  :active {
    background: #ffffff24;
  }
`
